<template>
  <div>
    <!--No hosts-->
    <div v-if="!game.stime1_host && !game.allSessionsCancelled">
      <div>
        <small
            v-if="!game.cancels1"
            class="has-text-success"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime1 && game.cancels1"
            class="has-text-danger line-throught"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime2 && !game.cancels2"
            class="has-text-success"
        > - {{ game.stime2 }}</small>
        <small
            v-if="game.stime2 && game.cancels2"
            class="has-text-danger line-throught"
        >{{ game.stime2 }}</small>
        <small
            v-if="game.stime3 && !game.cancels3"
            class="has-text-success"
        > - {{ game.stime3 }}</small>
        <small
            v-if="game.stime3 && game.cancels3"
            class="has-text-danger line-throught"
        >{{ game.stime3 }}</small>
        <small
            v-if="game.stime4 && !game.cancels4"
            class="has-text-success"
        > - {{ game.stime4 }}</small>
        <small
            v-if="game.stime4 && game.cancels4"
            class="has-text-danger line-throught"
        >{{ game.stime4 }}</small>
      </div>
    </div>
    <!--One Host-->
    <div v-if="game.stime1_host && !game.stime2_host && !game.allSessionsCancelled">
      <div>
        <small
            v-if="!game.cancels1"
            class="has-text-success"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime1 && game.cancels1"
            class="has-text-danger line-throught"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime2 && !game.cancels2"
            class="has-text-success"
        > - {{ game.stime2 }}</small>
        <small
            v-if="game.stime2 && game.cancels2"
            class="has-text-danger line-throught"
        >{{ game.stime2 }}</small>
        <small
            v-if="game.stime3 && !game.cancels3"
            class="has-text-success"
        > - {{ game.stime3 }}</small>
        <small
            v-if="game.stime3 && game.cancels3"
            class="has-text-danger line-throught"
        >{{ game.stime3 }}</small>
        <small
            v-if="game.stime4 && !game.cancels4"
            class="has-text-success"
        > - {{ game.stime4 }}</small>
        <small
            v-if="game.stime4 && game.cancels4"
            class="has-text-danger line-throught"
        >{{ game.stime4 }}</small>
      </div>
      <div>
        <small class="has-text-danger">{{ game.stime1_host.name }}</small>
      </div>
    </div>
    <!--Two hosts-->
    <div v-if="game.stime2_host && !game.stime3_host && !game.allSessionsCancelled">
      <div>
        <small
            v-if="!game.cancels1"
            class="has-text-success"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime1 && game.cancels1"
            class="has-text-danger line-throught"
        >{{ game.stime1 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime1_host"
            class="has-text-danger"
        >{{ game.stime1_host.name }}</small>
      </div>
      <div>
        <small
            v-if="game.stime2 && !game.cancels2"
            class="has-text-success"
        > - {{ game.stime2 }}</small>
        <small
            v-if="game.stime2 && game.cancels2"
            class="has-text-danger line-throught"
        >{{ game.stime2 }}</small>
        <small
            v-if="game.stime3 && !game.cancels3"
            class="has-text-success"
        > - {{ game.stime3 }}</small>
        <small
            v-if="game.stime3 && game.cancels3"
            class="has-text-danger line-throught"
        >{{ game.stime3 }}</small>
        <small
            v-if="game.stime4 && !game.cancels4"
            class="has-text-success"
        > - {{ game.stime4 }}</small>
        <small
            v-if="game.stime4 && game.cancels4"
            class="has-text-danger line-throught"
        >{{ game.stime4 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime2_host"
            class="has-text-danger"
        >{{ game.stime2_host.name }}</small>
      </div>
    </div>
    <!--Three hosts-->
    <div v-if="game.stime3_host && !game.stime4_host && !game.allSessionsCancelled">
      <div>
        <small
            v-if="!game.cancels1"
            class="has-text-success"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime1 && game.cancels1"
            class="has-text-danger line-throught"
        >{{ game.stime1 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime1_host"
            class="has-text-danger"
        >{{ game.stime1_host.name }}</small>
      </div>
      <div>
        <small
            v-if="game.stime2 && !game.cancels2"
            class="has-text-success"
        > - {{ game.stime2 }}</small>
        <small
            v-if="game.stime2 && game.cancels2"
            class="has-text-danger line-throught"
        >{{ game.stime2 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime2_host"
            class="has-text-danger"
        >{{ game.stime2_host.name }}</small>
      </div>
      <div>
        <small
            v-if="game.stime3 && !game.cancels3"
            class="has-text-success"
        > - {{ game.stime3 }}</small>
        <small
            v-if="game.stime3 && game.cancels3"
            class="has-text-danger line-throught"
        >{{ game.stime3 }}</small>
        <small
            v-if="game.stime4 && !game.cancels4"
            class="has-text-success"
        > - {{ game.stime4 }}</small>
        <small
            v-if="game.stime4 && game.cancels4"
            class="has-text-danger line-throught"
        >{{ game.stime4 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime3_host"
            class="has-text-danger"
        >{{ game.stime3_host.name }}</small>
      </div>
    </div>
    <!--Four hosts-->
    <div v-if="game.stime4_host && !game.allSessionsCancelled">
      <div>
        <small
            v-if="!game.cancels1"
            class="has-text-success"
        >{{ game.stime1 }}</small>
        <small
            v-if="game.stime1 && game.cancels1"
            class="has-text-danger line-throught"
        >{{ game.stime1 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime1_host"
            class="has-text-danger"
        >{{ game.stime1_host.name }}</small>
      </div>
      <div>
        <small
            v-if="game.stime2 && !game.cancels2"
            class="has-text-success"
        > - {{ game.stime2 }}</small>
        <small
            v-if="game.stime2 && game.cancels2"
            class="has-text-danger line-throught"
        >{{ game.stime2 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime2_host"
            class="has-text-danger"
        >{{ game.stime2_host.name }}</small>
      </div>
      <div>
        <small
            v-if="game.stime3 && !game.cancels3"
            class="has-text-success"
        > - {{ game.stime3 }}</small>
        <small
            v-if="game.stime3 && game.cancels3"
            class="has-text-danger line-throught"
        >{{ game.stime3 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime3_host"
            class="has-text-danger"
        >{{ game.stime3_host.name }}</small>
      </div>
      <div>
        <small
            v-if="game.stime4 && !game.cancels4"
            class="has-text-success"
        > - {{ game.stime4 }}</small>
        <small
            v-if="game.stime4 && game.cancels4"
            class="has-text-danger line-throught"
        >{{ game.stime4 }}</small>
      </div>
      <div>
        <small
            v-if="game.stime4_host"
            class="has-text-danger"
        >{{ game.stime4_host.name }}</small>
      </div>
    </div>
    <!--Game canceled and game's short note-->
    <div v-if="game.allSessionsCancelled">
      <!--All sessions canceled-->
      <p
          v-if="game.allSessionsCancelled"
          class="is-cancelled"
      >
        Cancelled
      </p>
    </div>
    <!--<div>
      <p
              class="is-cancelled"
      >
        Cancelled
      </p>
    </div>-->
    <small class="is-uppercase">{{ game.notes && cutNotes(game.notes) }}</small>
  </div>
</template>

<style scoped>
.is-cancelled {
  max-width: 150px;
  flex: 0;
  display: block;
  margin: 0 auto;
}
</style>

<script>
export default {
  props: ['game'],
  methods: {
    cutNotes(string) {
      return string.split('<br>')[0]
    }
  }
}
</script>